import TelegramIcon from '@mui/icons-material/Telegram';
import { Box, Link, Stack, Typography } from '@mui/material';
const contacts = [
    {
        label: 'Telegram',
        href: 'https://t.me/gamerushwin',
        icon: TelegramIcon,
    },
    {
        label: 'Telegram group',
        href: 'https://t.me/gamerush_news',
        icon: TelegramIcon,
    },
];

const SocialLinks = ({ isMobile }) => {
    return (
          <Box
            display="flex"
            flexDirection={isMobile ? 'row' : 'column'}
            alignItems={isMobile ? 'center' : 'flex-start'}
            justifyContent={isMobile ? 'center' : 'flex-start'}
            mb={isMobile ? 3 : 0}
          >
            <Stack direction="row" spacing={isMobile ? 4 : 2} alignItems="center" flexWrap="wrap">
                {contacts.map(({ label, href, icon: Icon }) => (
                    <Link
                        key={label}
                        href={href}
                        target={href.startsWith('mailto:') ? undefined : '_blank'}
                        rel={href.startsWith('mailto:') ? undefined : 'noreferrer'}
                        color="text.primary"
                        underline="none"
                        sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 1,
                            '&:hover': { color: 'primary.main' },
                        }}
                        aria-label={label}
                    >
                        <Icon fontSize="small" />
                        <Typography variant="body2" component="span">
                            {label}
                        </Typography>
                    </Link>
                ))}
            </Stack>
        </Box>
    );
};

export default SocialLinks;